import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Agenda from "@/pages/Agenda";
import Clientes from "@/pages/Clientes";
import Servicos from "@/pages/Servicos";
import Precificacao from "@/pages/Precificacao";
import Financeiro from "@/pages/Financeiro";
import Mais from "@/pages/Mais";
import Mensagens from "@/pages/Mensagens";
import Reativacao from "@/pages/Reativacao";
import Aniversarios from "@/pages/Aniversarios";
import Configuracoes from "@/pages/Configuracoes";
import Anamnese from "@/pages/Anamnese";
import Placeholder from "@/pages/Placeholder";
import BookingPublic from "@/pages/BookingPublic";
import Admin from "@/pages/Admin";
import Sales from "@/pages/Sales";
import Upsell from "@/pages/Upsell";
import Downsell from "@/pages/Downsell";
import PurchaseThanks from "@/pages/PurchaseThanks";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#71717A]">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "platform_admin") return <Navigate to="/admin" replace />;
  if (!user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#71717A]">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "platform_admin") return <Navigate to="/app" replace />;
  return children;
}

function AuthOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#71717A]">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "platform_admin") return <Navigate to="/admin" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[#71717A]">Carregando…</div>;
  if (user && user.role === "platform_admin") return <Navigate to="/admin" replace />;
  if (user && user.onboarding_completed) return <Navigate to="/app" replace />;
  if (user && !user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Sales />} />
            <Route path="/oferta/nail-designer-360" element={<Upsell />} />
            <Route path="/oferta/agenda-cheia" element={<Navigate to="/oferta/nail-designer-360" replace />} />
            <Route path="/oferta/downsell" element={<Downsell />} />
            <Route path="/obrigado" element={<PurchaseThanks />} />
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/register" element={<GuestOnly><Register /></GuestOnly>} />
            <Route path="/onboarding" element={<AuthOnly><Onboarding /></AuthOnly>} />
            <Route path="/agendar/:slug" element={<BookingPublic />} />
            <Route path="/admin" element={<AdminOnly><Admin /></AdminOnly>} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="clientes" element={<Clientes />} />
              <Route path="servicos" element={<Servicos />} />
              <Route path="precificacao" element={<Precificacao />} />
              <Route path="financeiro" element={<Financeiro />} />
              <Route path="mais" element={<Mais />} />
              <Route path="mensagens" element={<Mensagens />} />
              <Route path="reativacao" element={<Reativacao />} />
              <Route path="aniversarios" element={<Aniversarios />} />
              <Route path="materiais" element={<Placeholder title="Materiais" />} />
              <Route path="anamnese" element={<Anamnese />} />
              <Route path="link-publico" element={<Placeholder title="Autoagendamento" />} />
              <Route path="configuracoes" element={<Configuracoes />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
